<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='" background-image: url(\"https:\/\/api.tabibekhanevade.ir\/storage\/mezaj\/pngtree-herbal-plants-cosmetic-natural-plant-png-image_4904305.png\");"' class="h-100 bg-primary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="pt-5 " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container text-center bg-white p-5 rounded " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"\n  background: -webkit-linear-gradient(#23A9B3, #03045e);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;"' class="text-center my-5" >
                <template #default>مزاج شما سرد و تر (بلغمی)است.   </template>
                </m-h1><m-audio v-bind='{...{"audio":"https:\/\/api.tabibekhanevade.ir\/storage\/mezaj\/balgham.mp3"},...{}}' :style='""' class="col-8 my-4" ></m-audio><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>ویژگیهای ذیل مربوط به مزاج سرشتی افراد بلغمی می باشد.


هیکل بلغمی ها معمولاً درشت است و افرادی چاق هستند و بدن پر چربی دارند.
پوست سفید رنگ دارند و در لمس، پوست بدنشان سرد و مرطوب و نرم است.
موهای کم پشت دارند. دهانشان مرطوب است. تشنه نمی شوند. خواب آن ها سنگین و زیاد است. احساس کسلی و بیحالی دارند. تمایل به خوردن شیرینی و ادویه جات و گرمی جات دارند. در فصل زمستان خیلی اذیت می شوند. مستعد ابتلا به بیماریهای روماتیسمی و مشکلات گوارشی هستند. با خوردن سردی ها دچار مشکل می شوند. نبض ضعیف دارند. کم انرژی و کم جنب و جوش هستند و در کارها کند هستند خیلی دیر عصبانی می شوند. فراموشکار و کند ذهن هستند. افراد راحت و بی قید به اکثر مسائل هستند. همه چیز را راحت می گیرند و خود را درگیر چیزی نمی کنند. توان ریسک ندارند. بی اراده هستند . متاثر از دیگرانند. میل جنسی کم و توان جنسی کم دارند.
چندان قوی نیستند. همچنین با تأنی صحبت می کنند. اشتهایشان زیاد نیست و قدرت هضم بالایی ندارند.
سردی و رطوبت بدن توان جنسی آنها را کاهش می دهد.
بلغمی ها معمولاً افرادی آرام، صبور، تسلیم پذیر و مسالمت جو هستند، بیشتر دور اندیش و با احتیاط هستند و در انجام امور از خود شجاعت نشان نمی دهند، روابط اجتماعی آنان چندان قوی نیست و از حافظه و قدرت تمرکز بالایی برخوردار نمی باشند.

t.me/AlisinaTebeIrani
توصیه و تدابیر:
افراد بلغمی نبايد سردیجات را به تنهايی ميل كنند ( باید همراه با مصلحات ميل شود).
حجامت نیز برای بلغمی ها بدون نظر پزشک توصیه نمی شود.

علائم غلبه بلغم:
اگر تعادل میان اخلاط و مقدار آنها یا کیفیت هر یک از اخلاط بهم بخورد، موجب بیماری در بدن می شود یا به عبارتی موجب غلبه یک خلط بر اخلاط دیگر در بدن می شود که می بایست مورد درمان قرار گیرد که در ذیل علایم غلبه خلط بلغم ذکر شده است.

•    سفیدی رنگ پوست
•    نرمی وسردی پوست
•    کندی حواس
•    زیادشدن خواب
•    مدفوع بدبو
•    فراموشی وکند فهمی
•    ترشحات پشت حلق وبلغمی وسرفه زیاد
•    ضعف هضم وآروغ ترش زدن
•    افزایش آب دهان
•    افزایش اشتها
•    تجمع چربی شکمی
•    عدم تشنگی
•    ادرار سفیدرنگ
•    احساس کسلی و بی حالی   </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mAudio from '@moeinmdn/miw-alpha-components/src/package/Tags/Audio'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mAudio,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
